import React from 'react'

import { Role } from '../types'
import { useCredentials } from '@dentalux/security'
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material'

interface Props {
  label?: string
  value: Role | null
  options: Role[]
  onChange: (roleId: string) => void
  disabled?: boolean
}

const RolePicker: React.FC<Props> = ({ value, options, onChange, disabled = false }) => {
  const { authentication: user } = useCredentials()

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value)
  }

  return (
    <FormControl variant="outlined" sx={{ minWidth: 120 }}>
      <Select
        value={value?.referenceId || ''}
        disabled={disabled}
        onChange={handleChange}
        inputProps={{
          name: 'Timegroup',
          id: 'outlined-age-native-simple',
        }}
        MenuProps={{
          disablePortal: false,
          disableScrollLock: true,
          slotProps: {
            paper: {
              sx: {
                '&:hover': {
                  cursor: 'pointer',
                },
              },
            },
          },
          sx: {
            '& li:hover, li:focus': {
              backgroundColor: 'grey.100',
            },
          },
        }}
      >
        {options
          .filter((option) => option.name !== 'HQ_SUPER_ADMIN' || user?.role?.name === 'HQ_SUPER_ADMIN')
          .map((option) => (
            <MenuItem key={`option_${option.referenceId}`} value={option.referenceId}>
              {option.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  )
}

export default RolePicker
